export default __webpack_public_path__ + "static/media/ssc-wmdys.0ad58d30.png";